/* eslint-disable import/prefer-default-export */
export const CauzioniPaths = Object.freeze({
  base: '/private/prodotti/cauzione/richiesta-cauzione-fe',
});
